import permCheck from './permissioncheck';

export function createMenuItem(id, perm, title, url, icon, breadcrumbs) {
  return permCheck(perm)
    ? {
        id,
        perm,
        title,
        type: 'item',
        url,
        icon,
        breadcrumbs
      }
    : null;
}

export function createChildMenuItem(items) {
  let data = [];
  items.forEach((element) => {
    if (element) {
      data.push(element);
    }
  });
  return data;
}

export function createChildGroupMenuItem(items) {
  let data = [];

  items.forEach((element) => {
    if (element.type === 'collapse') {
      // Untuk collapse, muncul jika ada children yang visible
      // Jika ada perm, cek permission ATAU jika ada children yang visible
      if (element.perm) {
        if (permCheck(element.perm) && element.children?.length > 0) {
          data.push(element);
        } else if (element.children?.length > 0) {
          // Jika tidak punya parent perm, tetap muncul jika ada children yang visible
          data.push(element);
        }
      } else {
        if (element.children?.length > 0) {
          data.push(element);
        }
      }
    } else {
      if (element.perm) {
        if (permCheck(element.perm)) {
          data.push(element);
        }
      } else {
        data.push(element);
      }
    }
  });
  return data;
}
